import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';
import Icon from 'shared/components/Icon';
import CalendarActions from 'agent_portal/actions/CalendarActions';
import EditSlotForm from './EditSlotForm';
import classes from './ViewEditSlotModal.module.scss';

const ViewEditSlotModal = ({
  slot,
  showDestroySuccess,
  showSlotTakenNotice,
  referralIdThatTookSlot,
}) => {
  if (showDestroySuccess) {
    return (
      <div className={classes.container}>
        <div className={classes.modal_header}>Slot Removed</div>
        <div className={cx(classes.notice_container, classes.success)}>
          <div className={classes.notice_icon_container}>
            <Icon name="check-circle" />
          </div>
          Success
        </div>
      </div>
    );
  }

  if (showSlotTakenNotice) {
    // When the slot was taken before it could be deleted
    return (
      <div className={classes.container}>
        <div className={classes.modal_header}>Conflict: Slot Booked</div>
        <div className={cx(classes.notice_container, classes.warning)}>
          <div className={classes.notice_icon_container}>
            <Icon name="exclamation-triangle" />
          </div>
          <p>
            Slot was booked prior to deletion. You must cancel the appointment before you can delete
            the slot.
          </p>
          {referralIdThatTookSlot ? (
            <p>
              To cancel or view the appointment,{' '}
              <Link to={`/a/portal/referrals/${referralIdThatTookSlot}`}>
                please view the referral that booked this slot.
              </Link>
            </p>
          ) : null}
        </div>
      </div>
    );
  }

  const startMoment = moment(slot.startDate, 'YYYY-MM-DDTHH:mm:ss');
  const endMoment = moment(slot.endDate, 'YYYY-MM-DDTHH:mm:ss');
  const updateSlot = vals => {
    /* eslint-disable no-alert */
    if (
      !slot.taken ||
      window.confirm('This slot is already booked. Are you sure you want to change it?')
    ) {
      CalendarActions.updateSlot(slot.id, vals);
    }
    /* eslint-enable no-alert */
  };

  return (
    <div className={classes.container}>
      <div className={classes.modal_header}>Edit Slot</div>
      <EditSlotForm
        onUpdateSlot={updateSlot}
        selectionStart={startMoment.toDate()}
        selectionEnd={endMoment.toDate()}
        onDestroyClick={() => CalendarActions.destroySlot(slot.id)}
        initialValues={{
          selectionStartDate: startMoment.format('MM/DD/YYYY'),
          selectionEndDate: endMoment.format('MM/DD/YYYY'),
          selectionStartTime: startMoment.format('hh:mm a'),
          selectionEndTime: endMoment.format('hh:mm a'),
          repeatUnit: 'weekly',
          repeatStartsOn: startMoment.format('MM/DD/YYYY'),
          permitSelfReferral: slot.permitSelfReferrals,
          repeat: false,
          highPriorityOnly: slot.highPriorityOnly,
          locationId: slot.locationId,
        }}
      />
    </div>
  );
};

ViewEditSlotModal.displayName = 'ViewEditSlotModal';

function mapStateToProps({ calendar }) {
  return {
    slot: calendar.appointmentSlots.find(slot => slot.id === calendar.viewingSlotId),
    showDestroySuccess: calendar.showDestroySuccess,
    showSlotTakenNotice: calendar.showSlotTakenNotice,
    referralIdThatTookSlot: calendar.referralIdThatTookSlot,
  };
}

export default connect(mapStateToProps)(ViewEditSlotModal);
